import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiButton, EuiFormRow, EuiPage, EuiPageBody, EuiPageHeader, EuiPageHeaderSection, EuiPanel, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { useGetAIPlanBlueprintsQuery } from 'api/rtkQueryApi/platform/aiPlanBlueprintsApi'
import { RootState } from 'app/rootReducer'
import { reset } from 'features/planner/CreateAIPlanBlueprintSlice'

import history from '../../services/HistoryService'

export const AIPlanBlueprintWelcomePage: React.FC = () => {
  const dispatch = useDispatch()
  const { currentOrganization, currentAccount, isStaffUser, showInternalView } = useSelector((state: RootState) => state.app)
  const { data: blueprints } = useGetAIPlanBlueprintsQuery({ organizationId: currentOrganization?.id ?? '', showHidden: isStaffUser && showInternalView })

  useEffect(() => {
    if (!currentAccount || !blueprints) {
      return
    }

    const accountBlueprints = blueprints.filter(b => b.accountId === currentAccount?.id)

    if (accountBlueprints.length <= 0) {
      return
    }

    dispatch(reset())
    history.push('/ai/blueprints')
  }, [currentAccount, dispatch, blueprints])

  const onCreateBlueprintClick = () => {
    history.push('/ai/blueprints/create')
  }

  return (
    <EuiPage className='euiPage--platform'>
      <EuiPageBody>
        <EuiPageHeader>
          <EuiPageHeaderSection>
            <EuiTitle>
              <h1>AI Blueprints</h1>
            </EuiTitle>
            <EuiText>Welcome to AI Blueprints!</EuiText>
          </EuiPageHeaderSection>
        </EuiPageHeader>
        <EuiPanel grow={false} className='eui-xScroll'>
          <EuiTitle size={'s'}>
            <h2>Build Smarter Campaigns</h2>
          </EuiTitle>
          <EuiSpacer />
          <EuiText>To get started, simply enter your client's company name and website URL. Within twenty-four hours, AdCritter AI will generate a detailed market analysis and audience personas based on the company's industry and competitive landscape.</EuiText>
          <EuiSpacer />
          <EuiText>Once the blueprint is ready, you can review and edit the market analysis and personas to fine-tune your strategy.</EuiText>
          <EuiSpacer />
          <EuiText>Blueprints serve as the foundation for creating AI-powered media plans with strategically targeted campaigns.</EuiText>
          <EuiSpacer />
          <EuiFormRow>
            <EuiButton fill onClick={onCreateBlueprintClick}>
              Let's get started!
            </EuiButton>
          </EuiFormRow>
        </EuiPanel>
      </EuiPageBody>
    </EuiPage>
  )
}
